import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/shared/lib/store';

interface GuestRouteProps {
  children: React.ReactNode;
}

/**
 * Faqat login bo'lmagan userlar uchun routelar (masalan: /login).
 * Agar user allaqachon login bo'lgan bo'lsa, bosh sahifaga yo'naltiradi.
 */
export const GuestRoute = ({ children }: GuestRouteProps) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const location = useLocation();

  if (isAuthenticated) {
    // Agar oldingi sahifa bo'lsa, o'sha yerga qaytaramiz
    // Aks holda bosh sahifaga yo'naltiramiz
    const from = location.state?.from?.pathname || '/';
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
};
